import React from "react";
import project1 from '../assets/images/project1-ccms.jpg';
import project2 from '../assets/images/project2-pps.jpg';
import project3 from '../assets/images/project3-spmt.jpg';
import project4 from '../assets/images/project4-falling-detection.jpg';

import '../assets/styles/Project.scss';

function Experience() {
    return(
    <div className="projects-container" id="experience">
        <h1>Work Experience (Typical Projects)</h1>
        <div className="projects-grid">
            
            <div className="project">
                <img src={project1} className="zoom" alt="thumbnail" width="100%"/>
                <h2>Control Cable Management System (CCMS)</h2>
                <p><span style={{fontWeight: "bold"}}>Team Lead / Full-Stack Engineer / Bridge Engineer</span>
                    <br></br>
                    Led the development and maintenance of full-stack features for a cable management system using Java, Vue.js, and PostgreSQL, including AR-assisted field patrol support. Delivered successful customized deployments for several electric companies. <br></br>
                    Besides, acted as a bridge engineer, facilitating technical discussions, transferring domain knowledge, and clarifying requirements for the offshore team. Also mentored new team members to support onboarding and knowledge sharing.
                </p>
            </div>
            <div className="project">
                <img src={project4} className="zoom" alt="thumbnail" width="100%"/>
                <h2>Falling Detection (AI/ML Applied)</h2>
                <p><span style={{fontWeight: "bold"}}>Project Leader</span>
                    <br></br>
                    Led a collaborative project with the AI team to integrate AI-driven accident detection into power substation patrols. Used wearable devices to collect biological and motion data, which was analyzed by a trained model. The system detects falls or hazardous events and sends real-time alerts via email or SMS.
                </p>
            </div>
            <div className="project">
                <img src={project2} className="zoom" alt="thumbnail" width="100%"/>
                <h2>Power generation Performance statistics System (PPS)</h2>
                <p><span style={{fontWeight: "bold"}}>Tech Lead / Full-Stack Engineer</span>
                    <br></br>
                    Led the migration of a legacy Java system to a modern stack using Node.js and React. Redesigned the architecture and implemented CI/CD pipelines, improving performance, scalability, and development efficiency while preserving all core features.
                </p>
            </div>
            <div className="project">
                <img src={project3} className="zoom" alt="thumbnail" width="100%"/>
                <h2>Shipment Package Management Tool (SPMT)</h2>
                <p><span style={{fontWeight: "bold"}}>Tech Lead / Backend Engineer</span>
                    <br></br>
                    Proposed and led development of an internal automation tool using Python to streamline shipment-related procurement tasks. The tool generated and packaged required documents, reducing manual effort and errors. It was adopted team-wide, improving overall operational efficiency.
                </p>
            </div>
        </div>
    </div>
    );
}

export default Experience;